import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { damageControlApi, reportDamageControlFailure } from "@/api/damageControl";

// Consumers provide enabled and a contextKey covering booking, company and PDF reference.
export default {
  data: () => ({ busy: false, errorText: "", fallbackUrl: "", pdfDisposed: false, pendingWindow: null, sequence: 0 }),
  watch: { contextKey() { this.reset(); } },
  beforeDestroy() { this.pdfDisposed = true; this.reset(); },
  methods: {
    reset() {
      this.sequence += 1;
      if (this.pendingWindow) this.pendingWindow.close();
      this.pendingWindow = null;
      this.fallbackUrl = "";
      this.errorText = "";
      this.busy = false;
    },
    async openActPdf(reference) {
      if (!this.enabled || this.pdfDisposed || this.busy || (!reference && !this.bookingId) || (reference && !reference.ready)) return;
      const sequence = ++this.sequence;
      const context = this.contextKey;
      const active = () => !this.pdfDisposed && this.enabled && sequence === this.sequence && context === this.contextKey;
      const native = Capacitor.isNativePlatform();
      this.busy = true;
      this.errorText = "";
      try {
        // Reserve the tab during the user gesture, before the presigning request.
        const tab = native ? null : window.open("", "_blank");
        this.pendingWindow = tab;
        if (tab) tab.opener = null;
        if (!reference && this.bookingId) {
          const act = await damageControlApi.getAct(this.axios, this.bookingId);
          if (!active()) return;
          reference = act && act.current_pdf;
          if (!reference || !reference.ready) {
            this.errorText = this.$t("damage_control.act.pdf_unavailable");
            if (this.pendingWindow) this.pendingWindow.close();
            this.pendingWindow = null;
            return;
          }
        }
        const { url } = await damageControlApi.getActPdf(this.axios, reference.inspection_id);
        if (!active()) return;
        if (!url) throw new Error("Missing act PDF URL");
        if (native) await Browser.open({ url });
        else if (tab && !tab.closed) tab.location.href = url;
        else this.fallbackUrl = url;
        this.pendingWindow = null;
      } catch (error) {
        if (!active()) return;
        if (this.pendingWindow) this.pendingWindow.close();
        this.pendingWindow = null;
        this.errorText = reportDamageControlFailure(this, error, { silent: true });
      } finally {
        if (active()) this.busy = false;
      }
    },
  },
};
